import APIClient from './index';

export const getBrandCancellationPreview = brandId => {
  return new Promise((resolve, reject) => {
    APIClient.get(`AdminBrandCancellations/preview/${brandId}`)
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};

export const getBrandCancellations = () => {
  return new Promise((resolve, reject) => {
    APIClient.get(`AdminBrandCancellations`)
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};

export const queueBrandCancellation = data => {
  return new Promise((resolve, reject) => {
    APIClient.post(`AdminBrandCancellations`, data)
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};

export const updateAutomaticBrandCancellation = (brandId, updates) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`AdminBrandCancellations/automatic/${brandId}`, updates)
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};

export const cancelScheduledBrandCancellation = taskId => {
  return new Promise((resolve, reject) => {
    APIClient.delete(`AdminBrandCancellations/${taskId}`)
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
};
